module.exports = __webpack_public_path__ + "img/unsubscribe-img.af710c3c.svg";